import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  content: css`
    display: flex;
    align-items: center;
    max-width: 100%;
  `,

  professionalInfo: ({ spacing, colors }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: ${spacing.xs};

    p {
      max-width: 100%;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    span,
    p {
      color: ${colors.brand.primary[300]};
    }
  `,

  titleWrapper: css`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    max-width: 100%;
  `,

  arrowIcon: css`
    min-width: 20px;
    min-height: 20px;
  `,
})

export { useStyles }
